//@flow
import * as React from 'react';

type Props = {
  onClick: (factor: number) => void
};

const style = {
  color: '#209cee',
  cursor: 'pointer',
  textDecoration: 'underline'
};

const RentCalc: React.FC<Props> = props => {
  return (
    <span
      style={{
        marginBottom: '8px'
      }}
    >
      <span
        style={style}
        onClick={() => {
          props.onClick(1);
        }}
      >
        {'1 måned'}
      </span>
      ,{' '}
      <span
        style={style}
        onClick={() => {
          props.onClick(2);
        }}
      >
        {'2 måneder'}
      </span>{' '}
      {'eller'}{' '}
      <span
        style={style}
        onClick={() => {
          props.onClick(3);
        }}
      >
        {'3 måneder'}
      </span>
    </span>
  );
};

export default RentCalc;
